"use strict";
exports.__esModule = true;
var animation_1 = require("./core/animation");
var render_target_1 = require("./render-target/render-target");
var padding_1 = require("./core/padding");
var easing_functions_1 = require("./core/easing-functions");
var animable_object_1 = require("./core/animable-object");
var animated_text_container_1 = require("./core/animated-text-container");
var min_max_1 = require("./core/min-max");
var ChartColumnType;
(function (ChartColumnType) {
    ChartColumnType["x"] = "x";
    ChartColumnType["line"] = "line";
    ChartColumnType["bar"] = "bar";
    ChartColumnType["area"] = "area";
})(ChartColumnType = exports.ChartColumnType || (exports.ChartColumnType = {}));
var DataSet = /** @class */ (function () {
    function DataSet() {
    }
    return DataSet;
}());
exports.DataSet = DataSet;
var ZoomState = /** @class */ (function () {
    function ZoomState() {
    }
    return ZoomState;
}());
exports.ZoomState = ZoomState;
var DataToZoomStateMap = /** @class */ (function () {
    function DataToZoomStateMap() {
        //private data: Array<{ [xValue: number]: T }> = [];
        this.data = [];
    }
    DataToZoomStateMap.prototype.set = function (zoomState, o) {
        if (this.data[zoomState.zoomLevelIndex] == null) {
            this.data[zoomState.zoomLevelIndex] = [];
        }
        this.data[zoomState.zoomLevelIndex][zoomState.zoomedInXValue] = o;
        return this.data[zoomState.zoomLevelIndex][zoomState.zoomedInXValue];
    };
    DataToZoomStateMap.prototype.get = function (zoomState) {
        if (zoomState == null) {
            return null;
        }
        if (this.data.length - 1 < zoomState.zoomLevelIndex) {
            return null;
        }
        return this.data[zoomState.zoomLevelIndex][zoomState.zoomedInXValue];
    };
    return DataToZoomStateMap;
}());
exports.DataToZoomStateMap = DataToZoomStateMap;
var TelegramChart = /** @class */ (function () {
    function TelegramChart(document, containerElement, header) {
        var _this = this;
        this.document = document;
        this.containerElement = containerElement;
        this.renderTargets = [];
        this.zoomLevelsConfig = null;
        this.data = new DataToZoomStateMap();
        this.dataFrame = new DataToZoomStateMap();
        this.dataFramePerY = new DataToZoomStateMap();
        this.zoomStateStack = [];
        this.previousZoomState = null;
        this.currentZoomState = null;
        this.renderRequestId = null;
        this.zoomOutIconSvg = "<?xml version=\"1.0\" ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg enable-background=\"new 0 0 96 96\" height=\"96px\" id=\"zoom_out\" version=\"1.1\" viewBox=\"0 0 96 96\" width=\"96px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"M90.829,85.171L68.121,62.464C73.047,56.307,76,48.5,76,40C76,20.118,59.882,4,40,4C20.118,4,4,20.118,4,40s16.118,36,36,36  c8.5,0,16.306-2.953,22.464-7.879l22.708,22.708c1.562,1.562,4.095,1.562,5.657,0C92.391,89.267,92.391,86.733,90.829,85.171z   M40,68c-15.464,0-28-12.536-28-28s12.536-28,28-28c15.464,0,28,12.536,28,28S55.464,68,40,68z\"/><path d=\"M56,40c0,2.209-1.791,4-4,4H28c-2.209,0-4-1.791-4-4l0,0c0-2.209,1.791-4,4-4h24C54.209,36,56,37.791,56,40L56,40z\"/></svg>";
        this.lineColor = '#182d3b1a';
        this.tooltipLineColor = '#D2D5D7';
        this.backgroundColor = '#ffffff';
        this.animationsPool = [];
        this.animations = [];
        this.animationTimeMs = 400;
        this.animationYScaleEasing = easing_functions_1.EasingFunctions.easeInOutQuart;
        this.headerHElement = null;
        this.headerZoomOutElement = null;
        this.zoomControl = null;
        this.dataSelectorControl = null;
        this.selectedXValueIndex = null;
        this.recalculateYViewport = true;
        this.loadDataXhr = null;
        this.zoomInLoadDataHandlerBound = this.zoomInLoadDataHandler.bind(this);
        this.animationZoomViewPortDataFrameUpdateXMinBound = this.animationZoomViewPortDataFrameUpdateXMin.bind(this);
        this.animationZoomViewPortDataFrameUpdateXMaxBound = this.animationZoomViewPortDataFrameUpdateXMax.bind(this);
        this.animationZoomOpacityUpdateBound = this.animationZoomOpacityUpdate.bind(this);
        this.renderBound = this.render.bind(this);
        this.containerElement.style.position = 'relative';
        this.containerElement.style.overflow = 'hidden';
        this.headerHElement = document.createElement('h1');
        this.headerHElement.innerText = header;
        this.headerZoomOutElement = document.createElement('a');
        this.headerZoomOutElement.className = 'header-zoom-out';
        this.headerZoomOutElement.innerHTML = this.zoomOutIconSvg + "<span>Zoom Out</span>";
        this.headerZoomOutElement.onclick = function () {
            _this.zoomOut();
        };
        this.header = new animated_text_container_1.AnimatedTextContainer(document, 43, 350);
        this.header.element.className += ' chart-header';
        this.containerElement.appendChild(this.header.element);
        this.header.appendFromTop(this.headerHElement);
        var canvas = document.createElement('canvas');
        canvas.width = TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().width);
        canvas.height = TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().height - 40);
        canvas.className = 'telegram-chart';
        containerElement.appendChild(canvas);
        this.mainRenderTarget = new render_target_1.RenderTarget(this);
        this.mainRenderTarget.canvas = canvas;
        this.mainRenderTarget.yLabelsEnabled = true;
        this.mainRenderTarget.xLabelsEnabled = true;
        this.mainRenderTarget.autoAdjustYMax = true;
        this.mainRenderTarget.viewPortPadding = new padding_1.Padding();
        this.mainRenderTarget.viewPortPadding.top = TelegramChart.pixelsToCanvasSize(24);
        this.mainRenderTarget.viewPortPadding.bottom = TelegramChart.pixelsToCanvasSize(28);
        this.mainRenderTarget.viewPortPadding.left = TelegramChart.pixelsToCanvasSize(15);
        this.mainRenderTarget.viewPortPadding.right = TelegramChart.pixelsToCanvasSize(15);
        this.renderTargets.push(this.mainRenderTarget);
        for (var i = 0; i < 50; i++) {
            this.animationsPool.push(new animation_1.Animation());
        }
        window.addEventListener('resize', function () {
            console.log('resize');
            canvas.width = TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().width);
            canvas.height = TelegramChart.pixelsToCanvasSize(containerElement.getBoundingClientRect().height - 40);
            for (var i = 0; i < _this.renderTargets.length; i++) {
                _this.renderTargets[i].canvasHeight = null;
                _this.renderTargets[i].canvasWidth = null;
                _this.renderTargets[i].onResize();
                _this.renderTargets[i].viewportChanged = true;
            }
            if (_this.zoomControl) {
                _this.zoomControl.onResize();
            }
            _this.requestRender();
        });
    }
    TelegramChart.pixelsToCanvasSize = function (value) {
        return value * TelegramChart.canvasAspectRatio;
    };
    /**
     * @param canvas Adds canvas element to draw on. This can be used for previous, canvas maps etc.
     */
    TelegramChart.prototype.addRenderTarget = function (renderTarget) {
        this.renderTargets.push(renderTarget);
    };
    TelegramChart.prototype.set = function (data, zoomState) {
        if (data.columns.length < 2) {
            throw new Error('\'Columns\` array can not have less then two elements. ' +
                'There should always be one column of type \'x\' and at least one column of type \'line\'');
        }
        var xColumnFind = data['columns'].filter(function (c) { return data['types'][c[0]] == ChartColumnType.x; });
        if (xColumnFind.length < 1) {
            throw new Error('Column with type \'x\' must be provided');
        }
        else if (xColumnFind.length > 1) {
            throw new Error('Only one column of type \'x\' supported');
        }
        var xColumn = xColumnFind[0];
        this.data.set(zoomState, data);
        var dataFramePerY = this.calculateYMinMax(data);
        this.dataFramePerY.set(zoomState, dataFramePerY);
        this.dataFrame.set(zoomState, new render_target_1.DataFrameMinMax());
        var dataFrame = this.dataFrame.get(zoomState);
        dataFrame.x.min = xColumn[1];
        dataFrame.x.max = xColumn[xColumn.length - 1];
        dataFrame.y.min = dataFramePerY[TelegramChart.yAllName].min;
        dataFrame.y.max = dataFramePerY[TelegramChart.yAllName].max;
        for (var i = 0; i < this.renderTargets.length; i++) {
            var t = this.renderTargets[i];
            if (data['y_scaled']) {
                t.viewPortScalePerY = true;
            }
            t.dataFrame.set(zoomState, dataFrame.clone());
            t.viewPortDataFrame.set(zoomState, new render_target_1.DataFrameMinMax());
            var tViewPortDataFrame = t.viewPortDataFrame.get(zoomState);
            if (t.autoAdjustYMin) {
                if (tViewPortDataFrame.y.min == null) {
                    tViewPortDataFrame.y.min = this.roundYValue(dataFramePerY[TelegramChart.yAllName].min, true);
                }
            }
            else {
                tViewPortDataFrame.y.min = 0;
            }
            if (tViewPortDataFrame.y.max == null) {
                tViewPortDataFrame.y.max = this.roundYValue(dataFramePerY[TelegramChart.yAllName].max);
            }
            tViewPortDataFrame.x.min = dataFrame.x.min;
            tViewPortDataFrame.x.max = dataFrame.x.max;
            if (t.viewPortScalePerY) {
                for (var yId in dataFramePerY) {
                    if (yId == TelegramChart.yAllName) {
                        continue;
                    }
                    var viewPortDataFrameY = t.viewPortDataFramePerY.get(zoomState);
                    if (viewPortDataFrameY == null) {
                        viewPortDataFrameY = t.viewPortDataFramePerY.set(zoomState, {});
                    }
                    if (viewPortDataFrameY[yId] == null) {
                        viewPortDataFrameY[yId] = dataFramePerY[yId].clone();
                        if (t.autoAdjustYMin) {
                            viewPortDataFrameY[yId].min = this.roundYValue(viewPortDataFrameY[yId].min, true);
                        }
                        else {
                            tViewPortDataFrame.y.min = 0;
                        }
                        viewPortDataFrameY[yId].max = this.roundYValue(viewPortDataFrameY[yId].max);
                    }
                }
            }
        }
    };
    TelegramChart.prototype.loadData = function (oldZoomState, newZoomState, callback) {
        var _this = this;
        var zoomLevelConfig = this.zoomLevelsConfig[newZoomState.zoomLevelIndex];
        if (zoomLevelConfig == null) {
            return;
        }
        var url = zoomLevelConfig.dataUrlFunction(newZoomState.zoomedInXValue);
        var d = this.data.get(newZoomState);
        if (d != null) {
            callback(oldZoomState, newZoomState);
            return;
        }
        if (this.loadDataXhr != null) {
            this.loadDataXhr.abort();
        }
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function () {
            if (xhr.status != 200) {
                alert(xhr.status + ': ' + xhr.statusText);
                return;
            }
            var data = JSON.parse(xhr.responseText);
            _this.set(data, newZoomState);
            callback(oldZoomState, newZoomState);
            _this.loadDataXhr = null;
        };
        xhr.onerror = function () {
            alert(xhr.statusText);
        };
        xhr.send();
        this.loadDataXhr = xhr;
    };
    TelegramChart.prototype.zoomIn = function (zoomedInXValue) {
        var oldZoomState = this.currentZoomState;
        var newZoomState = null;
        if (this.zoomStateStack.length < 1) {
            newZoomState = new ZoomState();
            newZoomState.zoomLevelIndex = 0;
            newZoomState.zoomedInXValue = zoomedInXValue;
            newZoomState.config = this.zoomLevelsConfig[0];
            newZoomState.opacity = 1;
        }
        else {
            var currentZoomState = this.zoomStateStack[this.zoomStateStack.length - 1];
            newZoomState = new ZoomState();
            newZoomState.zoomLevelIndex = currentZoomState.zoomLevelIndex + 1;
            newZoomState.zoomedInXValue = zoomedInXValue;
            newZoomState.config = this.zoomLevelsConfig[newZoomState.zoomLevelIndex];
            newZoomState.opacity = 0;
            this.previousZoomState = currentZoomState;
        }
        this.loadData(oldZoomState, newZoomState, this.zoomInLoadDataHandlerBound);
    };
    TelegramChart.prototype.zoomInLoadDataHandler = function (oldZoomState, newZoomState) {
        this.zoomStateStack.push(newZoomState);
        this.currentZoomState = newZoomState;
        if (this.previousZoomState != null) {
            this.header.appendFromBottom(this.headerZoomOutElement);
        }
        for (var i = 0; i < this.renderTargets.length; i++) {
            this.renderTargets[i].onDataChange();
        }
        if (this.previousZoomState == null && this.zoomControl) {
            var viewPortDataFrame = this.mainRenderTarget.viewPortDataFrame.get(this.currentZoomState);
            viewPortDataFrame.x.min = viewPortDataFrame.x.max - (this.currentZoomState.config.xStep * 90);
            var dataFrame = this.mainRenderTarget.dataFrame.get(this.currentZoomState);
            var data = this.data.get(this.currentZoomState);
            var yDataFrame = this.calculateYMinMax(data, viewPortDataFrame.x.min, viewPortDataFrame.x.max, this.mainRenderTarget.yVisibility, this.mainRenderTarget.autoAdjustYMin ? null : 0);
            viewPortDataFrame.y.min = this.roundYValue(yDataFrame[TelegramChart.yAllName].min, true);
            viewPortDataFrame.y.max = this.roundYValue(yDataFrame[TelegramChart.yAllName].max);
            if (this.mainRenderTarget.viewPortScalePerY) {
                var viewPortDataFramePerY = this.mainRenderTarget.viewPortDataFramePerY.get(this.currentZoomState);
                for (var yId in yDataFrame) {
                    if (yId != TelegramChart.yAllName) {
                        viewPortDataFramePerY[yId].min = this.roundYValue(yDataFrame[yId].min, true);
                        viewPortDataFramePerY[yId].max = this.roundYValue(yDataFrame[yId].max);
                    }
                }
            }
            this.zoomControl.animateToValues(viewPortDataFrame.x.min, viewPortDataFrame.x.max, dataFrame.x);
        }
        if (this.dataSelectorControl) {
            this.dataSelectorControl.initializeButtons();
        }
        this.animateZoomChange(oldZoomState);
        this.requestRender();
    };
    TelegramChart.prototype.calculateYMinMax = function (data, fromX, toX, yVisibility, minYOverride) {
        if (fromX === void 0) { fromX = null; }
        if (toX === void 0) { toX = null; }
        if (yVisibility === void 0) { yVisibility = {}; }
        if (minYOverride === void 0) { minYOverride = null; }
        var minMaxY = {};
        if (data.percentage) {
            minMaxY[TelegramChart.yAllName] = new min_max_1.MinMax();
            minMaxY[TelegramChart.yAllName].min = 0;
            minMaxY[TelegramChart.yAllName].max = 100;
            return minMaxY;
        }
        minMaxY[TelegramChart.yAllName] = new min_max_1.MinMax();
        if (minYOverride != null) {
            minMaxY[TelegramChart.yAllName].min = minYOverride;
        }
        for (var xIndex = 1; xIndex < data['columns'][0].length; xIndex++) {
            var xValue = data['columns'][0][xIndex];
            if (fromX != null && xValue < fromX) {
                continue;
            }
            if (toX != null && xValue > toX) {
                continue;
            }
            for (var yIndex = 1; yIndex < data['columns'].length; yIndex++) { // start from 1 to skip 'x' column
                var yId = data['columns'][yIndex][0];
                if (yVisibility[yId] == null || yVisibility[yId] == true) {
                    var yValue = data['columns'][yIndex][xIndex];
                    if (data['stacked']) {
                        var sumOfPreviouslyRenderedYValues = 0;
                        for (var previousYIndex = 1; previousYIndex < yIndex; previousYIndex++) {
                            var previousYId = data['columns'][previousYIndex][0];
                            if (yVisibility[previousYId] == null || yVisibility[previousYId] == true) {
                                sumOfPreviouslyRenderedYValues += data['columns'][previousYIndex][xIndex];
                            }
                        }
                        yValue += sumOfPreviouslyRenderedYValues;
                    }
                    if (minMaxY[yId] == null) {
                        minMaxY[yId] = new min_max_1.MinMax();
                        if (minYOverride != null) {
                            minMaxY[yId].min = minYOverride;
                        }
                    }
                    if (minMaxY[yId].max == null || minMaxY[yId].max < yValue) {
                        minMaxY[yId].max = yValue;
                    }
                    if (minMaxY[TelegramChart.yAllName].max == null || minMaxY[TelegramChart.yAllName].max < yValue) {
                        minMaxY[TelegramChart.yAllName].max = yValue;
                    }
                    if (minYOverride == null) {
                        if (minMaxY[yId].min == null || minMaxY[yId].min > yValue) {
                            minMaxY[yId].min = yValue;
                        }
                        if (minMaxY[TelegramChart.yAllName].min == null || minMaxY[TelegramChart.yAllName].min > yValue) {
                            minMaxY[TelegramChart.yAllName].min = yValue;
                        }
                    }
                }
            }
        }
        return minMaxY;
    };
    TelegramChart.prototype.zoomOut = function () {
        this.header.appendFromTop(this.headerHElement);
        var oldZoomState = this.zoomStateStack.pop();
        this.currentZoomState = this.zoomStateStack[this.zoomStateStack.length - 1];
        this.previousZoomState = oldZoomState;
        this.animateZoomChange(oldZoomState, false);
        this.requestRender();
        if (this.dataSelectorControl) {
            this.dataSelectorControl.initializeButtons();
        }
    };
    TelegramChart.prototype.getZoomInState = function (zoomedInXValue) {
        var currentZoomState = this.zoomStateStack[this.zoomStateStack.length - 1];
        var newZoomState = new ZoomState();
        newZoomState.zoomLevelIndex = currentZoomState.zoomLevelIndex + 1;
        newZoomState.zoomedInXValue = zoomedInXValue;
        return newZoomState;
    };
    TelegramChart.prototype.selectXValueIndex = function (xValueIndex) {
        this.selectedXValueIndex = xValueIndex;
        var data = this.getCurrentZoomLevelData();
        var firstYId = data['columns'][1][0];
        var firstYType = data['types'][firstYId];
        if (firstYType == ChartColumnType.bar) {
            this.mainRenderTarget.canvas.style.opacity = '0.5';
        }
        //this.currentZoomState.opacity = 0.7;
        //this.mainRenderTarget.yOpacity[TelegramChart.yAllName] = .7;
        this.mainRenderTarget.viewportChanged = true;
        this.requestRender();
    };
    TelegramChart.prototype.unSelectXValue = function () {
        this.selectedXValueIndex = null;
        this.mainRenderTarget.canvas.style.opacity = '1';
        //this.currentZoomState.opacity = 1;
        //this.mainRenderTarget.yOpacity[TelegramChart.yAllName] = 1;
        this.mainRenderTarget.viewportChanged = true;
        this.requestRender();
    };
    TelegramChart.prototype.getDataSets = function (zoomState) {
        var data = this.data.get(zoomState);
        if (data == null) {
            return null;
        }
        return data['columns'].map(function (c) {
            var id = c[0];
            if (data['types'][id] != 'x') {
                var set = new DataSet();
                set.color = data['colors'][id];
                set.id = id.toString();
                set.label = data['names'][id];
                return set;
            }
            return null;
        }).filter(function (e) { return e; });
    };
    TelegramChart.prototype.animationZoomViewPortDataFrameUpdateXMin = function (renderTarget, viewPortDataFrame, value) {
        viewPortDataFrame.x.min = value;
        renderTarget.viewportChanged = true;
    };
    TelegramChart.prototype.animationZoomViewPortDataFrameUpdateXMax = function (renderTarget, viewPortDataFrame, value) {
        viewPortDataFrame.x.max = value;
        renderTarget.viewportChanged = true;
    };
    TelegramChart.prototype.animationZoomOpacityUpdate = function (renderTarget, zoomState, value) {
        zoomState.opacity = value;
        renderTarget.viewportChanged = true;
    };
    TelegramChart.prototype.animateZoomChange = function (previousZoomState, zoomIn) {
        var _this = this;
        if (zoomIn === void 0) { zoomIn = true; }
        this.unSelectXValue();
        var previousDuration = zoomIn ? 300 : 150;
        var newDuration = zoomIn ? 500 : 200;
        var scaleDuration = this.animationTimeMs;
        var zoomAnimationEasing = easing_functions_1.EasingFunctions.easeInOutQuart;
        this.recalculateYViewport = false;
        for (var i = 0; i < this.renderTargets.length; i++) {
            var t = this.renderTargets[i];
            t.onDataChange();
            /**
             * viewport of the level we are going to hide
             */
            var previousZoomViewPortDataFrame = t.viewPortDataFrame.get(previousZoomState);
            if (previousZoomViewPortDataFrame == null) {
                continue;
            }
            /**
             * viewport of the level we are going to show
             */
            var newZoomViewPortDataFrame = t.viewPortDataFrame.get(this.currentZoomState);
            if (newZoomViewPortDataFrame == null) {
                continue;
            }
            var previousTargetXMin = this.currentZoomState.zoomedInXValue;
            var previousTargetXMax = this.currentZoomState.zoomedInXValue;
            var newTargetXMin = newZoomViewPortDataFrame.x.min;
            var newTargetXMax = newZoomViewPortDataFrame.x.max;
            if (t == this.mainRenderTarget) {
                newTargetXMin = this.currentZoomState.zoomedInXValue;
                newTargetXMax = this.currentZoomState.zoomedInXValue + previousZoomState.config.xStep;
            }
            var savedViewPortDataFrame = t.viewPortDataFrameSaved.get(this.currentZoomState);
            if (savedViewPortDataFrame != null) {
                previousTargetXMin = savedViewPortDataFrame.x.min;
                previousTargetXMax = savedViewPortDataFrame.x.max;
                newTargetXMin = savedViewPortDataFrame.x.min;
                newTargetXMax = savedViewPortDataFrame.x.max;
            }
            // store viewport of previous zoom. If we will be zooming out later we want to show what was selected previously
            t.viewPortDataFrameSaved.set(previousZoomState, previousZoomViewPortDataFrame.clone());
            var animPreviousXMin = new animation_1.Animation();
            animPreviousXMin.animatedObject = t;
            animPreviousXMin.animatedChild = previousZoomViewPortDataFrame;
            animPreviousXMin.duration = scaleDuration;
            animPreviousXMin.easingFunction = zoomAnimationEasing;
            animPreviousXMin.startValue = previousZoomViewPortDataFrame.x.min;
            animPreviousXMin.endValue = previousTargetXMin;
            animPreviousXMin.update = this.animationZoomViewPortDataFrameUpdateXMinBound;
            this.addAnimation(animPreviousXMin);
            var animPreviousXMax = new animation_1.Animation();
            animPreviousXMax.animatedObject = t;
            animPreviousXMax.animatedChild = previousZoomViewPortDataFrame;
            animPreviousXMax.duration = scaleDuration;
            animPreviousXMax.easingFunction = zoomAnimationEasing;
            animPreviousXMax.startValue = previousZoomViewPortDataFrame.x.max;
            animPreviousXMax.endValue = previousTargetXMax;
            animPreviousXMax.update = this.animationZoomViewPortDataFrameUpdateXMaxBound;
            this.addAnimation(animPreviousXMax);
            var animNewXMin = new animation_1.Animation();
            animNewXMin.animatedObject = t;
            animNewXMin.animatedChild = newZoomViewPortDataFrame;
            animNewXMin.duration = scaleDuration;
            animNewXMin.easingFunction = zoomAnimationEasing;
            animNewXMin.startValue = previousZoomViewPortDataFrame.x.min;
            animNewXMin.endValue = newTargetXMin;
            animNewXMin.update = this.animationZoomViewPortDataFrameUpdateXMinBound;
            this.addAnimation(animNewXMin);
            var animNewXMax = new animation_1.Animation();
            animNewXMax.animatedObject = t;
            animNewXMax.animatedChild = newZoomViewPortDataFrame;
            animNewXMax.duration = scaleDuration;
            animNewXMax.easingFunction = zoomAnimationEasing;
            animNewXMax.startValue = previousZoomViewPortDataFrame.x.max;
            animNewXMax.endValue = newTargetXMax;
            animNewXMax.update = this.animationZoomViewPortDataFrameUpdateXMaxBound;
            animNewXMax.onFinished = function (o) {
                _this.recalculateYViewport = true;
                _this.requestRender();
            };
            this.addAnimation(animNewXMax);
            var animPreviousZoomStateOpacity = new animation_1.Animation();
            animPreviousZoomStateOpacity.animatedObject = t;
            animPreviousZoomStateOpacity.animatedChild = previousZoomState;
            animPreviousZoomStateOpacity.duration = previousDuration;
            animPreviousZoomStateOpacity.easingFunction = easing_functions_1.EasingFunctions.easeInOutCubic;
            animPreviousZoomStateOpacity.startValue = 1;
            animPreviousZoomStateOpacity.endValue = 0;
            animPreviousZoomStateOpacity.update = this.animationZoomOpacityUpdateBound;
            this.addAnimation(animPreviousZoomStateOpacity);
            var animNewZoomStateOpacity = new animation_1.Animation();
            animNewZoomStateOpacity.animatedObject = t;
            animNewZoomStateOpacity.animatedChild = this.currentZoomState;
            animNewZoomStateOpacity.duration = newDuration;
            animNewZoomStateOpacity.easingFunction = easing_functions_1.EasingFunctions.easeInOutCubic;
            animNewZoomStateOpacity.startValue = 0;
            animNewZoomStateOpacity.endValue = 1;
            animNewZoomStateOpacity.update = this.animationZoomOpacityUpdateBound;
            this.addAnimation(animNewZoomStateOpacity);
            //------------ animate zoom control
            if (t == this.mainRenderTarget) {
                var newDataFrame = t.dataFrame.get(this.currentZoomState);
                this.zoomControl.animateToValues(newTargetXMin, newTargetXMax, newDataFrame.x);
            }
            //------------ /animate zoom control
            var newYMinMax = this.calculateYMinMax(this.getCurrentZoomLevelData(), newTargetXMin, newTargetXMax, t.yVisibility, t.autoAdjustYMin ? null : 0);
            console.log(newYMinMax);
            if (t.viewPortScalePerY) {
                var newZoomViewPortDataFramePerY = t.viewPortDataFramePerY.get(this.currentZoomState);
                for (var _i = 0, _a = this.getDataSets(this.currentZoomState); _i < _a.length; _i++) {
                    var ds = _a[_i];
                    if (t.yVisibility[ds.id] == null || t.yVisibility[ds.id] == true) {
                        newZoomViewPortDataFramePerY[ds.id].min = this.roundYValue(newYMinMax[ds.id].min, true) - 1;
                        newZoomViewPortDataFramePerY[ds.id].max = this.roundYValue(newYMinMax[ds.id].max) - 1;
                        this.animateYMaxMinChange(newZoomViewPortDataFramePerY[ds.id].max + 1, newZoomViewPortDataFramePerY[ds.id].min + 1, t, this.currentZoomState, ds.id);
                    }
                }
            }
            else {
                newZoomViewPortDataFrame.y.min = this.roundYValue(newYMinMax[TelegramChart.yAllName].min, true) - 1;
                newZoomViewPortDataFrame.y.max = this.roundYValue(newYMinMax[TelegramChart.yAllName].max) - 1;
                this.animateYMaxMinChange(newZoomViewPortDataFrame.y.max + 1, newZoomViewPortDataFrame.y.min + 1, t, this.currentZoomState);
            }
        }
    };
    TelegramChart.prototype.getCurrentZoomLevelData = function () {
        return this.data.get(this.currentZoomState);
    };
    TelegramChart.prototype.getCurrentZoomLevelXColumn = function () {
        return this.getCurrentZoomLevelData()['columns'][0];
    };
    TelegramChart.prototype.getAnimation = function () {
        if (this.animationsPool.length > 0) {
            return this.animationsPool.pop().reset();
        }
        else {
            return new animation_1.Animation();
        }
    };
    TelegramChart.prototype.getXTooltipLabelFromValue = function (value) {
        var d = new Date(value);
        var dayName = TelegramChart.dayNames[d.getDay()];
        return dayName + ", " + TelegramChart.monthNames[d.getMonth()] + " " + d.getDate();
    };
    TelegramChart.prototype.animationYMaxUpdate = function (o, f, v) {
        f.max = v;
        o.viewportChanged = true;
    };
    ;
    TelegramChart.prototype.animationYMinUpdate = function (o, f, v) {
        f.min = v;
        o.viewportChanged = true;
    };
    ;
    TelegramChart.prototype.roundYValue = function (value, toLower) {
        if (toLower === void 0) { toLower = false; }
        var roundBy = 10;
        if (value >= 1000000) {
            roundBy = 1000000;
        }
        else if (value >= 100000) {
            roundBy = 20000;
        }
        else if (value >= 10000) {
            roundBy = 5000;
        }
        else if (value >= 1000) {
            roundBy = 500;
        }
        else if (value >= 100) {
            roundBy = 50;
        }
        return (toLower ? Math.floor(value / roundBy) : Math.ceil(value / roundBy)) * roundBy;
    };
    TelegramChart.prototype.addAnimation = function (a) {
        for (var i = 0; i < this.animations.length; i++) {
            if (this.animations[i] == null) {
                this.animations[i] = a;
                return;
            }
        }
        this.animations.push(a);
    };
    /**
     *
     * @param newYMax
     * @param newYMin
     * @param renderTarget
     * @param yId If of the data type where rescaling should happen. Pass null for scaling for all data types
     */
    TelegramChart.prototype.animateYMaxMinChange = function (newYMax, newYMin, renderTarget, zoomState, yId) {
        if (yId === void 0) { yId = null; }
        var animationAlreadyInProgressYMax = null;
        var animationAlreadyInProgressYMin = null;
        var yMaxAnimationName = "y-max-" + yId;
        var yMinAnimationName = "y-min-" + yId;
        for (var i = 0; i < this.animations.length; i++) {
            var anim = this.animations[i];
            if (anim != null && anim.animatedObject == renderTarget && anim.tag == yMaxAnimationName && anim.finished == false) {
                animationAlreadyInProgressYMax = anim;
                continue;
            }
            if (anim != null && anim.animatedObject == renderTarget && anim.tag == yMinAnimationName && anim.finished == false) {
                animationAlreadyInProgressYMin = anim;
                continue;
            }
            if (animationAlreadyInProgressYMax != null && animationAlreadyInProgressYMin != null) {
                break;
            }
        }
        var dataFrameY = renderTarget.viewPortDataFrame.get(zoomState).y;
        if (yId != null) {
            dataFrameY = renderTarget.viewPortDataFramePerY.get(zoomState)[yId];
        }
        if (animationAlreadyInProgressYMax == null && dataFrameY.max != newYMax) {
            var anim = this.getAnimation();
            anim.tag = yMaxAnimationName;
            anim.animatedObject = renderTarget;
            anim.animatedChild = dataFrameY;
            anim.duration = this.animationTimeMs;
            anim.easingFunction = this.animationYScaleEasing;
            anim.startValue = dataFrameY.max;
            anim.endValue = newYMax;
            anim.update = this.animationYMaxUpdate;
            this.addAnimation(anim);
            console.log("Animating " + yMaxAnimationName + " to " + newYMax);
            renderTarget.onYMinMaxChange(newYMin, newYMax, yId);
        }
        else if (animationAlreadyInProgressYMax != null && animationAlreadyInProgressYMax.endValue !== newYMax) {
            animationAlreadyInProgressYMax.startTime = null;
            animationAlreadyInProgressYMax.startValue = dataFrameY.max;
            animationAlreadyInProgressYMax.endValue = newYMax;
            renderTarget.onYMinMaxChange(newYMin, newYMax, yId);
        }
        if (animationAlreadyInProgressYMin == null && dataFrameY.min != newYMin) {
            var anim = this.getAnimation();
            anim.tag = yMinAnimationName;
            anim.animatedObject = renderTarget;
            anim.animatedChild = dataFrameY;
            anim.duration = this.animationTimeMs;
            anim.easingFunction = this.animationYScaleEasing;
            anim.startValue = dataFrameY.min;
            anim.endValue = newYMin;
            anim.update = this.animationYMinUpdate;
            this.addAnimation(anim);
            console.log("Animating " + yMinAnimationName + " to " + newYMin);
            renderTarget.onYMinMaxChange(newYMin, newYMax, yId);
        }
        else if (animationAlreadyInProgressYMin != null && animationAlreadyInProgressYMin.endValue !== newYMin) {
            animationAlreadyInProgressYMin.startTime = null;
            animationAlreadyInProgressYMin.startValue = dataFrameY.min;
            animationAlreadyInProgressYMin.endValue = newYMin;
            renderTarget.onYMinMaxChange(newYMin, newYMax, yId);
        }
    };
    TelegramChart.prototype.getLineColorByIndex = function (lineIndex, zoomState) {
        var d = this.data.get(zoomState);
        return d['colors'][d['columns'][lineIndex][0]];
    };
    TelegramChart.prototype.getLineColorById = function (lineId, zoomState) {
        var d = this.data.get(zoomState);
        return d['colors'][lineId];
    };
    TelegramChart.prototype.getLineName = function (lineIndex, zoomState) {
        var d = this.data.get(zoomState);
        return d['names'][d['columns'][lineIndex][0]];
    };
    TelegramChart.prototype.requestRender = function () {
        if (this.renderRequestId == null) {
            this.renderRequestId = window.requestAnimationFrame(this.renderBound);
        }
    };
    TelegramChart.prototype.render = function (timestamp) {
        this.renderRequestId = null;
        for (var a = 0; a < this.animations.length; a++) {
            if (this.animations[a] != null && this.animations[a].finished == false) {
                this.animations[a].step(timestamp);
                if (this.animations[a].finished) {
                    if (this.animations[a].animatedObject instanceof animable_object_1.AnimableObject) {
                        this.animations[a].animatedObject.animation = null;
                    }
                    this.animationsPool.push(this.animations[a]);
                    this.animations[a] = null;
                }
            }
        }
        for (var i = 0; i < this.renderTargets.length; i++) {
            var t = this.renderTargets[i];
            if (t.viewportChanged == false) {
                continue;
            }
            if (t.canvasContext == null) {
                t.canvasContext = t.canvas.getContext('2d');
                t.canvasContext.lineJoin = 'round';
            }
            if (t.canvasWidth == null) {
                t.canvasWidth = t.canvas.width;
            }
            if (t.canvasHeight == null) {
                t.canvasHeight = t.canvas.height;
            }
            var ctx = t.canvasContext;
            ctx.clearRect(0, 0, t.canvasWidth, t.canvasHeight);
            t.renderBackground();
            var dataFrame = t.dataFrame.get(this.currentZoomState);
            if (dataFrame == null) {
                continue;
            }
            dataFrame.y.max = -Infinity;
            dataFrame.y.min = Infinity;
            ctx.lineWidth = t.lineWidth;
            var d = this.data.get(this.currentZoomState);
            var renderTargetDataFrame = t.dataFrame.get(this.currentZoomState);
            var renderTargetViewPortDataFrame = t.viewPortDataFrame.get(this.currentZoomState);
            if (d != null && d['columns'] != null) {
                this.renderZoomLevel(t, renderTargetDataFrame, renderTargetViewPortDataFrame, d, this.currentZoomState);
            }
            if (this.previousZoomState != null) {
                var previousD = this.data.get(this.previousZoomState);
                var previousRenderTargetDataFrame = t.dataFrame.get(this.previousZoomState);
                var previousRenderTargetViewPortDataFrame = t.viewPortDataFrame.get(this.previousZoomState);
                if (previousD != null && previousD['columns'] != null) {
                    this.renderZoomLevel(t, previousRenderTargetDataFrame, previousRenderTargetViewPortDataFrame, previousD, this.previousZoomState);
                }
            }
            if (this.recalculateYViewport) {
                renderTargetDataFrame.y.max = this.roundYValue(renderTargetDataFrame.y.max);
                renderTargetDataFrame.y.min = this.roundYValue(renderTargetDataFrame.y.min, true);
                if (t.viewPortScalePerY) {
                    var renderTargetDataFramePerYMap = t.dataFramePerY.get(this.currentZoomState);
                    var renderTargetvViewPortDataFramePerY = t.viewPortDataFramePerY.get(this.currentZoomState);
                    for (var yId in renderTargetDataFramePerYMap) {
                        renderTargetDataFramePerYMap[yId].max = this.roundYValue(renderTargetDataFramePerYMap[yId].max);
                        renderTargetDataFramePerYMap[yId].min = this.roundYValue(renderTargetDataFramePerYMap[yId].min, true);
                        var yMaxShouldChange = renderTargetDataFramePerYMap[yId].max != renderTargetvViewPortDataFramePerY[yId].max && renderTargetDataFramePerYMap[yId].max > -1 && t.autoAdjustYMax;
                        var yMinShouldChange = renderTargetDataFramePerYMap[yId].min != renderTargetvViewPortDataFramePerY[yId].min && renderTargetDataFramePerYMap[yId].min < Infinity && t.autoAdjustYMin;
                        if (yMaxShouldChange || yMinShouldChange) {
                            this.animateYMaxMinChange(yMaxShouldChange ? renderTargetDataFramePerYMap[yId].max : renderTargetvViewPortDataFramePerY[yId].max, yMinShouldChange ? renderTargetDataFramePerYMap[yId].min : renderTargetvViewPortDataFramePerY[yId].min, t, this.currentZoomState, yId);
                        }
                    }
                }
                else {
                    var yMaxShouldChange = renderTargetDataFrame.y.max != renderTargetViewPortDataFrame.y.max && renderTargetDataFrame.y.max > -1 && t.autoAdjustYMax;
                    var yMinShouldChange = renderTargetDataFrame.y.min != renderTargetViewPortDataFrame.y.min && renderTargetDataFrame.y.min < Infinity && t.autoAdjustYMin;
                    if (yMaxShouldChange || yMinShouldChange) {
                        this.animateYMaxMinChange(yMaxShouldChange ? renderTargetDataFrame.y.max : renderTargetViewPortDataFrame.y.max, yMinShouldChange ? renderTargetDataFrame.y.min : renderTargetViewPortDataFrame.y.min, t, this.currentZoomState);
                    }
                }
            }
            t.renderForeground();
            t.viewportChanged = false;
        }
        for (var i = 0; i < this.animations.length; i++) {
            if (this.animations[i] != null) {
                if (!this.animations[i].finished) {
                    this.requestRender();
                    return;
                }
            }
        }
    };
    TelegramChart.prototype.yStepForward = function (y, yTo) {
        if (y < yTo) {
            return ++y;
        }
        return null;
    };
    TelegramChart.prototype.yStepBackward = function (y, yTo) {
        if (y > yTo) {
            return --y;
        }
        return null;
    };
    TelegramChart.prototype.renderZoomLevel = function (t, renderTargetDataFrame, renderTargetViewPortDataFrame, d, zoomState) {
        var ctx = t.canvasContext;
        var xColumn = d['columns'][0];
        var quality = TelegramChart.pixelsToCanvasSize(t.quality);
        var xStepWidth = this.xValueToCanvasPosition(renderTargetViewPortDataFrame.x.min + zoomState.config.xStep, t, zoomState, 0, //t.viewPortPadding.left,
        0 //t.viewPortPadding.right,
        );
        var xStepWidthHalf = Math.round(xStepWidth / 2);
        if (xStepWidthHalf < 1) {
            xStepWidthHalf = 1;
        }
        var y = 0;
        var yTo = d['columns'].length - 1;
        var yStep = this.yStepForward;
        if (d['stacked']) {
            y = d['columns'].length;
            yTo = 1;
            yStep = this.yStepBackward;
        }
        while ((y = yStep(y, yTo)) !== null) {
            var yColumn = d['columns'][y];
            var yId = yColumn[0];
            if (t.yOpacity[yId] == null) {
                t.yOpacity[yId] = 1;
            }
            else if (t.yOpacity[yId] == 0) {
                continue;
            }
            var type = d['types'][yId];
            var yAdjustDataFrame = t.yVisibility[yId];
            if (yAdjustDataFrame == null) {
                yAdjustDataFrame = true;
            }
            var dataFramePerYMap = t.dataFramePerY.get(zoomState);
            if (dataFramePerYMap == null) {
                dataFramePerYMap = t.dataFramePerY.set(zoomState, {});
            }
            if (dataFramePerYMap[yId] == null) {
                dataFramePerYMap[yId] = new min_max_1.MinMax();
            }
            var dataFramePerY = dataFramePerYMap[yId];
            if (!d['percentage']) {
                dataFramePerY.max = -Infinity;
                dataFramePerY.min = Infinity;
                ctx.globalAlpha = t.yOpacity[yId] * zoomState.opacity;
            }
            var yColor = this.getLineColorByIndex(y, zoomState);
            ctx.beginPath();
            ctx.strokeStyle = yColor;
            ctx.fillStyle = yColor;
            var firstDrawnXValueInCanvasCoords = null;
            var previouslyDrawnXValueInCanvasCoords = null;
            var previouslyDrawnYValueInCanvasCoords = null;
            var firstElementToDraw = true;
            var xColumnLength = xColumn.length;
            for (var x = 1; x < xColumnLength; x++) {
                var xValue = xColumn[x];
                var yValueNotAnimated = yColumn[x];
                var yValue = yColumn[x];
                var prevXValue = xValue;
                var nextXValue = xValue;
                if (x > 5 && x < xColumn.length) {
                    prevXValue = xColumn[x - 5];
                }
                if (x < xColumn.length - 5) {
                    nextXValue = xColumn[x + 5];
                }
                if ((nextXValue > renderTargetViewPortDataFrame.x.min && prevXValue < renderTargetViewPortDataFrame.x.max) ||
                    (renderTargetViewPortDataFrame.x.min == null && renderTargetViewPortDataFrame.x.max == null)) {
                    var total = 0;
                    var sumOfPreviouslyRenderedYValues = 0;
                    var sumOfPreviouslyRenderedYValuesNotAnimated = 0;
                    if (type == ChartColumnType.bar) {
                        if (t.yOpacity[yId] != null) {
                            yValue = yValue * t.yOpacity[yId];
                        }
                        for (var previousYIndex = 1; previousYIndex < y; previousYIndex++) {
                            var previousYId = d['columns'][previousYIndex][0];
                            if (t.yOpacity[previousYId] == null) {
                                t.yOpacity[previousYId] = 1;
                            }
                            var previousYValue = d['columns'][previousYIndex][x];
                            var previousYValueNotAnimated = 0;
                            if (t.yVisibility[previousYId] == null || t.yVisibility[previousYId] == true) {
                                previousYValueNotAnimated = previousYValue;
                            }
                            previousYValue = previousYValue * t.yOpacity[previousYId];
                            sumOfPreviouslyRenderedYValues += previousYValue;
                            sumOfPreviouslyRenderedYValuesNotAnimated += previousYValueNotAnimated;
                        }
                        yValue += sumOfPreviouslyRenderedYValues;
                        yValueNotAnimated += sumOfPreviouslyRenderedYValuesNotAnimated;
                    }
                    if (type == ChartColumnType.area) {
                        if (t.yOpacity[yId] != null) {
                            yValue = yValue * t.yOpacity[yId];
                        }
                        for (var previousYIndex = 1; previousYIndex < d['columns'].length; previousYIndex++) {
                            var previousYId = d['columns'][previousYIndex][0];
                            if (t.yOpacity[previousYId] == null) {
                                t.yOpacity[previousYId] = 1;
                            }
                            var previousYValue = d['columns'][previousYIndex][x];
                            previousYValue = previousYValue * t.yOpacity[previousYId];
                            total += previousYValue;
                            if (previousYIndex > y) {
                                sumOfPreviouslyRenderedYValues += previousYValue;
                            }
                        }
                        var yPreviouslyRenderedValuesInPercents = (sumOfPreviouslyRenderedYValues / total) * 100;
                        yValue = 100 - yPreviouslyRenderedValuesInPercents;
                    }
                    if (!d['percentage']) {
                        if (yValueNotAnimated < renderTargetDataFrame.y.min && yAdjustDataFrame) {
                            renderTargetDataFrame.y.min = yValueNotAnimated;
                        }
                        if (yValueNotAnimated > renderTargetDataFrame.y.max && yAdjustDataFrame) {
                            renderTargetDataFrame.y.max = yValueNotAnimated;
                        }
                        if (yValueNotAnimated < dataFramePerY.min && yAdjustDataFrame) {
                            dataFramePerY.min = yValueNotAnimated;
                        }
                        if (yValueNotAnimated > dataFramePerY.max && yAdjustDataFrame) {
                            dataFramePerY.max = yValueNotAnimated;
                        }
                    }
                    var xValueInCanvasCoords = this.xValueToCanvasPosition(xValue, t, zoomState, t.viewPortPadding.left, t.viewPortPadding.right);
                    var yValueInCanvasCoords = this.yValueToCanvasPosition(yValue, t, zoomState, t.viewPortPadding.top, t.viewPortPadding.bottom, t.viewPortScalePerY ? yId : null);
                    // // square distance between 2 points
                    // function getSqDist(p1, p2) {
                    //     var dx = p1.x - p2.x,
                    //         dy = p1.y - p2.y;
                    //     return dx * dx + dy * dy;
                    // }
                    var distance = Infinity;
                    if (previouslyDrawnXValueInCanvasCoords == null || previouslyDrawnYValueInCanvasCoords == null) {
                        previouslyDrawnXValueInCanvasCoords = xValueInCanvasCoords;
                        previouslyDrawnYValueInCanvasCoords = yValueInCanvasCoords;
                    }
                    else {
                        var dx = xValueInCanvasCoords - previouslyDrawnXValueInCanvasCoords;
                        var dy = yValueInCanvasCoords - previouslyDrawnYValueInCanvasCoords;
                        distance = dx * dx + dy * dy;
                    }
                    if (distance > quality) {
                        if (type == ChartColumnType.line) {
                            if (firstElementToDraw) {
                                ctx.moveTo(xValueInCanvasCoords, yValueInCanvasCoords);
                            }
                            else {
                                ctx.lineTo(xValueInCanvasCoords, yValueInCanvasCoords);
                            }
                        }
                        else if (type == ChartColumnType.bar) {
                            if (firstElementToDraw) {
                                ctx.moveTo(xValueInCanvasCoords, t.canvasHeight - t.viewPortPadding.bottom);
                            }
                            ctx.lineTo(previouslyDrawnXValueInCanvasCoords, yValueInCanvasCoords);
                            ctx.lineTo(xValueInCanvasCoords + xStepWidthHalf, yValueInCanvasCoords);
                        }
                        else if (type == ChartColumnType.area) {
                            // const halfWidth = t.canvasWidth / 2;
                            // const halfHeight = t.canvasHeight / 2;
                            // var radians = (Math.PI / 180) * -30,
                            // cos = Math.cos(radians),
                            // sin = Math.sin(radians),
                            // nx = (cos * (xValueInCanvasCoords - halfWidth)) + (sin * (yValueInCanvasCoords - halfHeight)) + halfWidth,
                            // ny = (cos * (yValueInCanvasCoords - halfHeight)) - (sin * (xValueInCanvasCoords - halfWidth)) + halfHeight;
                            // ctx.lineTo(
                            //     nx,
                            //     ny
                            // );
                            ctx.lineTo(xValueInCanvasCoords, yValueInCanvasCoords);
                        }
                        previouslyDrawnXValueInCanvasCoords = xValueInCanvasCoords + xStepWidthHalf;
                        previouslyDrawnYValueInCanvasCoords = yValueInCanvasCoords;
                    }
                    firstElementToDraw = false;
                    if (firstDrawnXValueInCanvasCoords == null) {
                        firstDrawnXValueInCanvasCoords = xValueInCanvasCoords;
                    }
                }
            }
            if (type == ChartColumnType.line) {
                ctx.stroke();
            }
            else if (type == ChartColumnType.bar) {
                ctx.lineTo(previouslyDrawnXValueInCanvasCoords, t.canvasHeight - t.viewPortPadding.bottom);
                ctx.lineTo(t.viewPortPadding.left, t.canvasHeight - t.viewPortPadding.bottom);
                ctx.fill();
            }
            else if (type == ChartColumnType.area) {
                ctx.lineTo(previouslyDrawnXValueInCanvasCoords - xStepWidthHalf, t.canvasHeight - t.viewPortPadding.bottom);
                ctx.lineTo(firstDrawnXValueInCanvasCoords, t.canvasHeight - t.viewPortPadding.bottom);
                ctx.fill();
            }
            if (!d['percentage']) {
                t.dataFramePerY.set(zoomState, dataFramePerYMap);
            }
        }
    };
    TelegramChart.prototype.findDataXIndexForCanvasPosition = function (canvasX, renderTarget, zoomState) {
        var paddings = renderTarget.viewPortPadding.left + renderTarget.viewPortPadding.right;
        var visibleFrameRatio = (canvasX - renderTarget.viewPortPadding.left) / (renderTarget.canvasWidth - paddings);
        var viewPortDataFrame = renderTarget.viewPortDataFrame.get(zoomState);
        if (viewPortDataFrame == null) {
            return null;
        }
        var min = viewPortDataFrame.x.min;
        var max = viewPortDataFrame.x.max;
        var visibleFrame = max - min;
        var valueToFind = min + (visibleFrame * visibleFrameRatio);
        var dataFrame = this.dataFrame.get(zoomState);
        var totalFrameRatio = (valueToFind - dataFrame.x.min) / (dataFrame.x.max - dataFrame.x.min);
        var indexFound = this.findNearestDataXIndexForValue(valueToFind, totalFrameRatio, zoomState);
        return indexFound;
    };
    TelegramChart.prototype.findNearestDataXIndexForValue = function (value, hintRatio, zoomState) {
        var d = this.data.get(zoomState);
        var column = d["columns"][0];
        var index = Math.round((column.length - 2) * hintRatio) + 1;
        if (index >= column.length - 1 || value > column[column.length - 1]) {
            return column.length - 1;
        }
        if (index <= 1) {
            return 1;
        }
        if (value > column[index] && index < column.length - 1 && value < column[index + 1]) {
            return index;
        }
        if (value < column[index] && index > 0 && value > column[index - 1]) {
            return index;
        }
        var found = false;
        while (!found) {
            if (value == column[index]) {
                return index;
            }
            else if (value > column[index] && index < column.length - 1 && value < column[index + 1]) {
                return index;
            }
            else if (value < column[index] && index > 0 && value > column[index - 1]) {
                return index;
            }
            if (value < column[index]) {
                index--;
            }
            else {
                index++;
            }
            if (index > column.length - 1) {
                return column.length - 1;
            }
            if (index <= 1) {
                return 1;
            }
        }
        return 1;
    };
    TelegramChart.prototype.xValueToCanvasPosition = function (xValue, renderTarget, zoomState, paddingLeft, paddingRight, width) {
        if (paddingLeft === void 0) { paddingLeft = 0; }
        if (paddingRight === void 0) { paddingRight = 0; }
        if (width === void 0) { width = null; }
        if (width == null) {
            width = renderTarget.canvasWidth - paddingLeft - paddingRight;
        }
        var dataFrame = this.dataFrame.get(zoomState);
        if (dataFrame == null) {
            return null;
        }
        var min = dataFrame.x.min;
        var max = dataFrame.x.max;
        var renderTargetViewPortDataFrame = renderTarget.viewPortDataFrame.get(zoomState);
        if (renderTargetViewPortDataFrame.x.max != null &&
            renderTargetViewPortDataFrame.x.min != null) {
            min = renderTargetViewPortDataFrame.x.min;
            max = renderTargetViewPortDataFrame.x.max;
        }
        var frame = max - min;
        var xValueDifferenceWithMin = xValue - min;
        var xValueRatio = xValueDifferenceWithMin / frame;
        var xPosition = width * xValueRatio;
        return Math.round(xPosition + paddingLeft);
    };
    TelegramChart.prototype.yValueToCanvasPosition = function (yValue, renderTarget, zoomState, paddingTop, paddingBottom, yId) {
        if (paddingTop === void 0) { paddingTop = 0; }
        if (paddingBottom === void 0) { paddingBottom = 0; }
        if (yId === void 0) { yId = null; }
        var height = renderTarget.canvasHeight - paddingTop - paddingBottom;
        var dataFrame = this.dataFrame.get(zoomState);
        if (dataFrame == null) {
            return null;
        }
        var min = dataFrame.y.min;
        var max = dataFrame.y.max;
        if (yId == null) {
            var renderTargetViewPortDataFrame = renderTarget.viewPortDataFrame.get(zoomState);
            if (renderTargetViewPortDataFrame.y.min != null && renderTargetViewPortDataFrame.y.max != null) {
                min = renderTargetViewPortDataFrame.y.min;
                max = renderTargetViewPortDataFrame.y.max;
            }
        }
        else {
            var viewPortDataFrameForY = renderTarget.viewPortDataFramePerY.get(zoomState)[yId];
            if (viewPortDataFrameForY != null && viewPortDataFrameForY.min != null && viewPortDataFrameForY.max != null) {
                min = viewPortDataFrameForY.min;
                max = viewPortDataFrameForY.max;
            }
        }
        var frame = max - min;
        var valueDifferenceWithMin = yValue - min;
        var valueRatio = valueDifferenceWithMin / frame;
        var valuePosition = height * valueRatio;
        return Math.round(height - valuePosition + paddingTop);
    };
    TelegramChart.oneDayMilliseconds = 1000 * 60 * 60 * 24;
    TelegramChart.oneHourMilliseconds = 1000 * 60 * 60;
    TelegramChart.canvasAspectRatio = window.devicePixelRatio;
    TelegramChart.dayNames = [
        'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
    ];
    TelegramChart.monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    TelegramChart.yAllName = 'all';
    return TelegramChart;
}());
exports.TelegramChart = TelegramChart;
//# sourceMappingURL=telegram-chart.js.map